import React from "react";
import { Check, SkipForward, X } from "lucide-react";

const YesNo = ({ question, value = null, onChange, showSkip = true, inlineView = false }) => {
  const getButtonClasses = (isActive, type) => {
    // Base classes differ based on inlineView
    const baseClasses = inlineView
      ? `
        flex items-center gap-1 px-4 py-2
        rounded-md font-medium text-default
        border border-gray-200
        transition-all duration-300 ease-in-out
        transform hover:scale-105 hover:shadow-sm
      `
      : `
        flex items-center gap-2 px-8 py-4
        rounded-lg font-medium text-lg
        border border-gray-200
        transition-all duration-300 ease-in-out
        transform hover:scale-105 hover:shadow-md
      `;

    // Active states
    if (isActive) {
      switch (type) {
        case "yes":
          return `
            ${baseClasses} 
            bg-emerald-100 text-emerald-700 border-emerald-500
          `;
        case "no":
          return `
            ${baseClasses} 
            bg-red-100 text-red-700 border-red-500
          `;
        case "skip":
          return `
            ${baseClasses} 
            bg-blue-50 text-blue-700 border-blue-500
          `;
        default:
          return baseClasses;
      }
    }

    // Inactive states
    return `
      ${baseClasses} 
      bg-white text-gray-600
    `;
  };

  // Adjust icon sizes based on inlineView
  const iconSize = inlineView ? "w-4 h-4" : "w-6 h-6";

  return (
    <div className={`w-full ${inlineView ? "" : "max-w-2xl mx-auto"}`}>
      <div className={`flex flex-wrap ${inlineView ? "gap-2" : "gap-4"} items-center justify-start ${inlineView ? "mt-2" : "mt-8"}`}>
        <button
          onClick={() => onChange(true)}
          className={getButtonClasses(value === true, "yes")}
        >
          <Check className={`${iconSize} ${value === true ? "text-emerald-600" : ""}`} />
          <span>Yes</span>
        </button>

        <button
          onClick={() => onChange(false)}
          className={getButtonClasses(value === false, "no")}
        >
          <X className={`${iconSize} ${value === false ? "text-red-600" : ""}`} />
          <span>No</span>
        </button>

        {showSkip && (
          <button
            onClick={() => onChange(null)}
            className={getButtonClasses(value === null, "skip")}
          >
            <SkipForward className={`${iconSize} ${value === null ? "text-blue-600" : ""}`} />
            <span>Skip</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default YesNo;